import React from "react";

interface DotMatrixAccentProps {
  position?: "top-right" | "bottom-left" | "top-left" | "bottom-right" | "center";
  size?: "sm" | "md" | "lg";
  dark?: boolean;
  className?: string;
}

export function DotMatrixAccent({
  position = "top-right",
  size = "md",
  dark = false,
  className,
}: DotMatrixAccentProps) {
  const sizeMap = {
    sm: "w-24 h-24",
    md: "w-40 h-40",
    lg: "w-64 h-64",
  };

  const positionMap = {
    "top-right": "top-0 right-0",
    "bottom-left": "bottom-0 left-0",
    "top-left": "top-0 left-0",
    "bottom-right": "bottom-0 right-0",
    "center": "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
  };

  const maskMap = {
    "top-right": "radial-gradient(ellipse at top right, black 0%, transparent 70%)",
    "bottom-left": "radial-gradient(ellipse at bottom left, black 0%, transparent 70%)",
    "top-left": "radial-gradient(ellipse at top left, black 0%, transparent 70%)",
    "bottom-right": "radial-gradient(ellipse at bottom right, black 0%, transparent 70%)",
    "center": "radial-gradient(ellipse at center, black 0%, transparent 70%)",
  };

  const dotColor = dark
    ? "var(--cream-12)"
    : "var(--charcoal-14)";

  return (
    <div
      className={`absolute ${positionMap[position]} ${sizeMap[size]} pointer-events-none ${className ?? ""}`}
      aria-hidden="true"
      style={{
        backgroundImage: `radial-gradient(circle, ${dotColor} 1px, transparent 1px)`,
        backgroundSize: "14px 14px",
        maskImage: maskMap[position],
        WebkitMaskImage: maskMap[position],
      }}
    />
  );
}
